import { Box, CircularProgress } from "@mui/material";

const DataLoader = () => {
    return (
        <Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%"
        }}>
            <CircularProgress size="3rem" />
        </Box>
    )
};


export default DataLoader;